import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Briefcase, CalendarDays, Users } from 'lucide-react';

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } }
};

const ProjectCard = ({ project }) => {
  return (
    <motion.div variants={cardVariants}>
      <Card className="bg-slate-800/70 border-slate-700 shadow-xl hover:shadow-blue-500/30 transition-shadow duration-300 h-full flex flex-col">
        <CardHeader>
          <div className="flex items-center mb-2">
            <Briefcase className="h-6 w-6 text-blue-400 mr-3" />
            <CardTitle className="text-xl text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">{project.name}</CardTitle>
          </div>
          <CardDescription className="text-slate-400 line-clamp-2 h-10">{project.description || 'No description available.'}</CardDescription>
        </CardHeader>
        <CardContent className="flex-grow">
          <div className="text-sm text-slate-300">
            <span className="font-semibold text-slate-100">Template:</span> {project.template || 'N/A'}
          </div>
        </CardContent>
        <CardFooter className="text-xs text-slate-500 border-t border-slate-700 pt-4 mt-auto">
          <div className="flex items-center mr-4">
            <CalendarDays className="h-3.5 w-3.5 mr-1.5" />
            <span>Created: {new Date(project.created_at).toLocaleDateString()}</span>
          </div>
        </CardFooter>
      </Card>
    </motion.div>
  );
};

export default ProjectCard;